/** Sentinel for "all accounting areas" on the month-end checklist page (matches API counts key). */
export const MONTH_END_CHECKLIST_ALL_AREAS_KEY = "ALL";

/** Canonical month-end checklist accounting areas (admin template + sidebar counts). */
export const MONTH_END_CHECKLIST_ACCOUNTING_AREAS: string[] = [
  "Revenue",
  "Cost of revenue",
  "Employee cost",
  "Other expenses",
  "Depreciation / PPE",
  "GST",
  "TDS",
  "Vendor advance",
  "Customer advance",
  "Accounts receivable",
  "Accounts payable",
  "Other assets",
  "Other liabilities",
];

export const MONTH_END_CHECKLIST_ACCOUNTING_AREA_OPTIONS =
  MONTH_END_CHECKLIST_ACCOUNTING_AREAS.map((value) => ({
    value,
    label: value,
  }));

export type ChecklistItemPriority = "high" | "medium" | "low";

export const CHECKLIST_ITEM_PRIORITY_OPTIONS: {
  value: ChecklistItemPriority;
  label: string;
}[] = [
  { value: "high", label: "HIGH" },
  { value: "medium", label: "MEDIUM" },
  { value: "low", label: "LOW" },
];

/** Matches backend month_end_checklist_items / template_items status ENUM. */
export const MONTH_END_CHECKLIST_ITEM_WORKFLOW_STATUSES = [
  "not_started",
  "in_progress",
  "done",
  "submitted_for_review",
  "approved",
  "rejected",
  "to_be_done_later",
] as const;

export type MonthEndChecklistItemWorkflowStatus =
  (typeof MONTH_END_CHECKLIST_ITEM_WORKFLOW_STATUSES)[number];

export function parseMonthEndChecklistItemWorkflowStatus(
  value: unknown,
): MonthEndChecklistItemWorkflowStatus {
  if (
    typeof value === "string" &&
    (MONTH_END_CHECKLIST_ITEM_WORKFLOW_STATUSES as readonly string[]).includes(
      value,
    )
  ) {
    return value as MonthEndChecklistItemWorkflowStatus;
  }
  return "not_started";
}
